var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { StyledButtonV2 } from 'components/Shared/StyledButtonV2/StyledButtonV2';
import { InputFieldType } from 'models/Input/InputModels';
import { useEffect, useMemo, useState } from 'react';
import { Form, useLocation, useNavigate, useNavigation, useSearchParams } from 'react-router-dom';
import { PubTable } from 'components/Shared/PubTable/PubTable';
import { determineChannelVal } from 'components/ProductBuildNew/ProductBuildSearchFormV2/ProductBuildSearchFormV2';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { getProductsV2 } from 'services/api/search-product-service';
import { searchParamsHelper } from 'components/ProductBuildNew/searchParamsHelper';
import { getUTCDateData } from 'components/ProductBuild/helper';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import styles from './ProductSearchNewListResults.module.scss';
export function ProductSearchNewListSearch() {
    var _this = this;
    var _a, _b;
    var sParams = useSearchParams()[0];
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var params = useMemo(function () {
        var _a, _b, _c, _d;
        var p = {
            text: (_a = sParams.get('search')) !== null && _a !== void 0 ? _a : '',
            date: (_b = sParams.get('date')) !== null && _b !== void 0 ? _b : '',
            time: (_c = sParams.get('time')) !== null && _c !== void 0 ? _c : '',
            rbv: (_d = sParams.get('channel')) !== null && _d !== void 0 ? _d : '',
        };
        return p;
    }, [sParams]);
    var searchParams = useMemo(function () { return searchParamsHelper(false, params.text, params); }, [params]);
    var _c = useState({
        text: searchParams.text,
        date: searchParams.date,
        displayDate: searchParams.displayDate,
        time: searchParams.time,
        displayTime: searchParams.displayTime,
        rbv: searchParams.rbv,
    }), searchData = _c[0], setSearchData = _c[1];
    var _d = useState(false), areCPAColumnsPresent = _d[0], setAreCPAColumnsPresent = _d[1];
    var createTableDefinition = function (optionalColumns) {
        var defaultTable = {
            firstColumnIndent: true,
            noDataMessage: 'No Products found',
            columns: [
                {
                    dataAttribute: 'prefix',
                    fieldType: InputFieldType.STRING,
                    heading: 'Product Prefix',
                    width: optionalColumns ? '7%' : '12%',
                    allowCopy: true,
                    index: 0,
                    setOverflowWrap: 'break-word',
                },
                {
                    dataAttribute: 'name',
                    fieldType: InputFieldType.STRING,
                    heading: 'Product Name',
                    width: optionalColumns ? '25%' : '35%',
                    allowCopy: true,
                    index: 1,
                },
                {
                    dataAttribute: 'discountString',
                    fieldType: InputFieldType.STRING,
                    heading: 'Discount',
                    width: optionalColumns ? '20%' : '30%',
                    index: 2,
                },
                {
                    dataAttribute: 'startDate',
                    fieldType: InputFieldType.STRING,
                    heading: 'Start Date',
                    width: optionalColumns ? '13%' : '23%',
                    index: 5,
                },
            ],
            showAddRow: false,
            extraIconIsActionText: true,
            extraIcon: {
                icon: null,
                dateAndTimeStrings: {
                    date: searchData.date,
                    time: searchData.time,
                },
            },
        };
        if (optionalColumns) {
            var cols = __spreadArray(__spreadArray(__spreadArray([], defaultTable.columns.slice(0, 3), true), [
                {
                    dataAttribute: 'standardProductRef',
                    fieldType: InputFieldType.STRING,
                    heading: 'Standard Product Ref.',
                    width: '20%',
                    index: 3,
                    setOverflowWrap: 'anywhere',
                },
                {
                    dataAttribute: 'deviations',
                    fieldType: InputFieldType.STRING,
                    heading: 'Deviations',
                    width: '15%',
                    index: 4,
                }
            ], false), defaultTable.columns.slice(3), true);
            defaultTable.columns = cols;
        }
        else if (defaultTable.columns.length > 4) {
            var indexOfVersion = defaultTable.columns.findIndex(function (item) { return item.dataAttribute === 'standardProductRef'; });
            defaultTable.columns.splice(indexOfVersion, 2);
        }
        return defaultTable;
    };
    var _e = useState(createTableDefinition()), tableDefinition = _e[0], setTableDefinition = _e[1];
    var location = useLocation();
    var navigate = useNavigate();
    var navigation = useNavigation();
    var _f = useState(1), pageNo = _f[0], setPageNo = _f[1];
    var _g = useState(false), isLoading = _g[0], setIsLoading = _g[1];
    var _h = useState((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.resultsCount), totalCount = _h[0], setTotalCount = _h[1];
    var paginationCount = useMemo(function () { return Math.ceil(totalCount / 50); }, [totalCount]);
    var _j = useState({ present: false, direction: '' }), sort = _j[0], setSort = _j[1];
    var sortLabels = useMemo(function () { return ['Relevance', 'Product Prefix Asc', 'Product Prefix Desc']; }, []);
    var _k = useState('Relevance'), selectedSortLabel = _k[0], setSelectedSortLabel = _k[1];
    var handle500Error = function () {
        setIsLoading(false);
        setSnackbarAlert({
            message: 'Server Error - Please report the error to the PLS support board/help desk with details',
            type: 'error',
        });
    };
    var getSort = function (col) {
        var sortObj = { present: false, direction: '' };
        if (col.toLowerCase().includes('prefix')) {
            sortObj.present = true;
            if (col.toLowerCase().includes('asc')) {
                sortObj.direction = 'asc';
            }
            else {
                sortObj.direction = 'desc';
            }
        }
        return sortObj;
    };
    var handleSortLabelsSelect = function (col) { return __awaiter(_this, void 0, void 0, function () {
        var text, date, time, rbv, sortObj, rsp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    if (selectedSortLabel !== col) {
                        setSelectedSortLabel(col);
                    }
                    else {
                        setSelectedSortLabel('');
                    }
                    text = searchData.text, date = searchData.date, time = searchData.time, rbv = searchData.rbv;
                    sortObj = getSort(col);
                    setSort(sortObj);
                    setPageNo(1);
                    return [4 /*yield*/, getProductsV2(text, date, time, determineChannelVal(rbv), 1, sortObj)];
                case 1:
                    rsp = _a.sent();
                    if (rsp.status >= 500) {
                        handle500Error();
                        return [2 /*return*/];
                    }
                    setTableData(formattedData(rsp.data.data));
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var formattedData = function (response) {
        var _a, _b;
        var apiData;
        if (response) {
            apiData = response;
        }
        else {
            apiData = (_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data;
        }
        var mappedData = apiData === null || apiData === void 0 ? void 0 : apiData.map(function (p) {
            var _a, _b, _c, _d, _e, _f;
            var splitDate = (_b = (_a = p === null || p === void 0 ? void 0 : p.startDate) === null || _a === void 0 ? void 0 : _a.split('T')[0]) === null || _b === void 0 ? void 0 : _b.split('-');
            var splitTime = (_d = (_c = p === null || p === void 0 ? void 0 : p.startDate) === null || _c === void 0 ? void 0 : _c.split('T')[1]) === null || _d === void 0 ? void 0 : _d.split(':');
            return {
                prefix: p === null || p === void 0 ? void 0 : p.prefix,
                name: (_f = (_e = p === null || p === void 0 ? void 0 : p.productName) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.desc,
                discountString: getDiscountString(p === null || p === void 0 ? void 0 : p.discountDesc, p === null || p === void 0 ? void 0 : p.discountCode),
                startDate: "".concat(splitDate[0], "/").concat(splitDate[1], "/").concat(splitDate[2], " @ ").concat(splitTime[0], ":").concat(splitTime[1].replace('Z', '')),
                version: p === null || p === void 0 ? void 0 : p.productVersion,
                id: p === null || p === void 0 ? void 0 : p.productId,
                standardProductRef: p === null || p === void 0 ? void 0 : p.standardProdRef,
                deviations: p === null || p === void 0 ? void 0 : p.deviationDesc,
            };
        });
        return mappedData;
    };
    var _l = useState(formattedData()), tableData = _l[0], setTableData = _l[1];
    useEffect(function () {
        if (!tableData) {
            handleSearchButtonClick();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSearchDataValueChange = function (field, val) {
        var data = __assign({}, searchData);
        data[field] = val;
        if (field === 'date') {
            data.date = getUTCDateData(val, data.displayTime).date;
            data.displayDate = val;
        }
        else if (field === 'time') {
            var _a = getUTCDateData(data.displayDate, val), date = _a.date, time = _a.time;
            data.time = time;
            data.date = date;
            data.displayTime = val;
        }
        setSearchData(data);
    };
    var disableButton = useMemo(function () { return !searchData.text || !searchData.date || !searchData.time; }, [searchData]);
    var handlePageChange = function (event, value) { return __awaiter(_this, void 0, void 0, function () {
        var text, date, time, rbv, paginatorResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setPageNo(value);
                    setIsLoading(true);
                    text = params.text, date = params.date, time = params.time, rbv = params.rbv;
                    setSearchData(searchParamsHelper(false, text, params));
                    return [4 /*yield*/, getProductsV2(text, date, time, determineChannelVal(rbv), value, sort)];
                case 1:
                    paginatorResponse = _b.sent();
                    if (paginatorResponse.status >= 500) {
                        handle500Error();
                        return [2 /*return*/];
                    }
                    if (paginatorResponse.status === 200 && ((_a = paginatorResponse.data) === null || _a === void 0 ? void 0 : _a.data)) {
                        setTableData(formattedData(paginatorResponse.data.data));
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var resultsText = useMemo(function () {
        return "Showing ".concat(pageNo * 50 - 49, " - ").concat(pageNo * 50 > totalCount ? totalCount : pageNo * 50, " of ").concat(totalCount, " results");
    }, [pageNo, totalCount]);
    var handleToggleCpaColumns = function () {
        setAreCPAColumnsPresent(function (prevVal) {
            setTableDefinition(createTableDefinition(!prevVal));
            return !prevVal;
        });
    };
    var handleSearchButtonClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var text, date, time, rbv, rsp;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setSelectedSortLabel('Relevance');
                    setIsLoading(true);
                    text = searchData.text, date = searchData.date, time = searchData.time, rbv = searchData.rbv;
                    return [4 /*yield*/, getProductsV2(text, date, time, determineChannelVal(rbv))];
                case 1:
                    rsp = _d.sent();
                    if (rsp.status >= 500) {
                        handle500Error();
                        return [2 /*return*/];
                    }
                    if (rsp.status === 200 && ((_a = rsp.data) === null || _a === void 0 ? void 0 : _a.data)) {
                        setPageNo(1);
                        navigate("/search-v2/simple/list?search=".concat(text, "&date=").concat(date, "&time=").concat(time, "&channel=").concat(rbv), { state: rsp });
                        setTableData(formattedData(rsp.data.data));
                        setTotalCount((_c = (_b = rsp.data) === null || _b === void 0 ? void 0 : _b.resultsCount) !== null && _c !== void 0 ? _c : 0);
                        setIsLoading(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var component = function () {
        if (navigation.state !== 'loading') {
            return (_jsx(Form, { children: _jsxs(Box, { children: [_jsxs(Box, __assign({ className: styles.form }, { children: [_jsx("h1", __assign({ className: styles.title }, { children: "Simple Search" })), _jsxs(Box, __assign({ className: styles.searchContainer, sx: { width: '40%' } }, { children: [_jsx(PubInputField, { labels: { left: 'Name or Partial Product Number', right: 'Required' }, fieldType: InputFieldType.STRING, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.text, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('text', e); }, formInputName: "productNbr", validations: { required: 'This is a required field' }, dirtyCheck: true }), _jsx(Box, __assign({ className: styles.rbContainer }, { children: _jsx(PubInputField, { fieldType: InputFieldType.RADIO, fieldValue: searchData.rbv, fieldOptions: ['Commercial', 'GSA', 'B2B'], fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('rbv', e); }, labels: { left: 'Channel' } }) }))] })), _jsx(Box, __assign({ className: styles.searchContainer }, { children: _jsx(PubInputField, { labels: { left: 'Date' }, fieldType: InputFieldType.DATE, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayDate, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('date', e); }, formInputName: "date", validations: { required: 'This is a required field' }, dirtyCheck: true, showErrorAdornment: false }) })), _jsx(Box, __assign({ className: styles.searchContainer, sx: { width: '140px' } }, { children: _jsx(PubInputField, { labels: { left: 'Time' }, fieldType: InputFieldType.TIME, fieldValue: searchData === null || searchData === void 0 ? void 0 : searchData.displayTime, fieldValueUpdateHandler: function (e) { return handleSearchDataValueChange('time', e); }, formInputName: "time", validations: { required: 'This is a required field' }, dirtyCheck: true, showErrorAdornment: false }) })), _jsx(Box, __assign({ className: styles.buttonContainer }, { children: _jsx(StyledButtonV2, { type: "submit", labelText: "Search", height: "35px", disabled: disableButton, buttonAction: function () { return handleSearchButtonClick(); } }) }))] })), _jsx("hr", { style: { height: '0', borderTop: '1px solid black', margin: '8px 40px' } }), _jsxs(Box, __assign({ sx: { display: 'flex', justifyContent: 'center' } }, { children: [!isLoading && (_jsxs(Box, __assign({ sx: {
                                        marginLeft: '40px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    } }, { children: [_jsx("h3", __assign({ style: { margin: 0, fontSize: '14px' } }, { children: totalCount > 0 && resultsText })), totalCount > 50 && (_jsx(Pagination, { count: paginationCount, onChange: function (e, num) { return handlePageChange(e, num); }, page: pageNo }))] }))), _jsxs(Box, __assign({ sx: {
                                        display: 'flex',
                                        marginLeft: 'auto',
                                        marginRight: '40px',
                                        alignItems: 'center',
                                    } }, { children: [_jsx(PubInputField, { fieldType: InputFieldType.SWITCH, fieldValueUpdateHandler: function () { return handleToggleCpaColumns(); }, switchLabel: "Include CPA Columns", switchWidth: 250, defaultChecked: areCPAColumnsPresent }), _jsx(FormControl, __assign({ sx: { m: 1, width: 250 } }, { children: _jsx(Select, __assign({ value: selectedSortLabel, sx: { height: '40px' } }, { children: sortLabels === null || sortLabels === void 0 ? void 0 : sortLabels.map(function (col) { return (_jsx(MenuItem, __assign({ value: col, onClick: function () { return handleSortLabelsSelect(col); } }, { children: _jsx(ListItemText, { primary: col }) }), col)); }) })) }))] }))] })), !isLoading && tableData ? (_jsx(Box, __assign({ sx: { margin: '0 40px' } }, { children: _jsx(PubTable, { def: tableDefinition, tableData: tableData, renderTableHeader: tableData.length > 0, origin: "simple" }) }))) : (_jsx(LoadingSpinner, { indicatorSize: 10 }))] }) }));
        }
        return _jsx(LoadingSpinner, { indicatorSize: 10 });
    };
    return component();
}
export var getDiscountString = function (desc, code) {
    if (!desc) {
        if (!code) {
            return '';
        }
        return code;
    }
    return "".concat(desc, " - ").concat(code);
};
